import React from 'react';
import { Image } from '@chakra-ui/react';
import {
  Pressable,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';

const chevronRight = '/chevron-right-small.svg';

type Props = {
  disabled?: boolean;
  onClick: () => void;
  subText: string;
  text: string;
};

export const MeetingTypeButton = ({
  disabled = false,
  onClick,
  subText,
  text,
}: Props) => {
  return (
    <Pressable
      alignItems={'center'}
      bgColor={disabled ? 'white' : 'feather.100'}
      borderColor={'cloud.200'}
      borderWidth={1}
      borderRadius={'8px'}
      disabled={disabled}
      display={'flex'}
      flexDir={'row'}
      height={'48px'}
      justifyContent={'space-between'}
      maxW={'260px'}
      w={'100%'}
      onClick={onClick}
      position={'relative'}
      px={'16px'}
      py={'4px'}
    >
      <VStack>
        <Text
          color={disabled ? 'muted.300' : 'secondary.500'}
          fontSize={'xs'}
          fontWeight={'normal'}
          pl={2}
        >
          {text}
        </Text>

        <Text
          color={disabled ? 'muted.300' : 'blueGray.600'}
          fontSize={'2xs'}
          fontWeight={'normal'}
          pl={2}
        >
          {subText}
        </Text>
      </VStack>

      {!disabled && (
        <Image
          alt={'chevron button icon'}
          boxSize={'20px'}
          src={chevronRight}
        />
      )}
    </Pressable>
  );
};
